__turbopack_context__.v({
  "orderIcons": "JQPWlG_orderIcons",
  "orderTitle": "JQPWlG_orderTitle",
  "orderWrapper": "JQPWlG_orderWrapper",
  "row": "JQPWlG_row",
  "tabletContent": "JQPWlG_tabletContent",
  "webContent": "JQPWlG_webContent",
});
